import React from "react";
import { useSelector } from "react-redux";
import { Redirect, useParams } from "react-router-dom";

// For routes that can only be accessed by authenticated users
function AuthGuard({ children }) {
  const auth = useSelector((state) => state.authReducer);
  const userToken = localStorage.getItem('access_token');
  const params = useParams();

  if (!auth.user && !userToken) {
    if (params.organizationSlug !== undefined) {
      let url = `/auth/${params.organizationSlug}/verify?redirect_url=/overview/${params.organizationSlug}`;
      return <Redirect to={url} />;
    } else {
      return <Redirect to={'/500'} />;
    }
  }

  return children;
}

export default AuthGuard;
